import { CEDatafeedBase } from './ce-datafeed-base'


export class CEDatafeed extends CEDatafeedBase {

}